import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

import { getBackgroundColorStyleForColour } from '@/modules/colours/helpers';
import { type ColourAttribute } from '@/modules/search/types';

export function ColourCircle({
  colour,
  colourClassName,
  labelClassName,
}: {
  colour: ColourAttribute;
  colourClassName?: string;
  labelClassName?: string;
}) {
  return (
    <div className={styles.colourFilterOptionLabelContainer}>
      <div
        className={clsx(
          styles.colourFilterColourSpot,
          colour.id === 'white' && styles.greyBorder,
          colourClassName
        )}
        style={
          {
            '--background-image': getBackgroundColorStyleForColour(colour.id),
            '--background-color': '#' + colour.hexCode,
            '--border-color': colour.hexCode,
          } as React.CSSProperties
        }
      />
      <span className={labelClassName}>{colour.nameI18N}</span>
    </div>
  );
}
